<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconLogoSquare",
    props: {
        icon_color: {
            require: false,
            default: '#28375a',
        }
    }
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="img-fluid" id="outputsvg" style="transform: none; transform-origin: 50% 50%; transition: none;" viewBox="235 52 4510 4044.04">
        <g id="l1aFi7DQDM5FTPkeIOQ4bAu" fill="rgb(39,54,89)" style="transform: none;">
            <g style="transform: none;">
                <path id="p37DTkSkH" d="M2820 2805 c0 -516 -3 -795 -10 -795 -5 0 -121 50 -257 111 l-246 111 -281 -116 c-155 -63 -289 -118 -299 -122 -16 -6 -17 33 -15 780 2 521 0 785 -7 783 -5 -2 -338 -120 -740 -261 l-730 -257 0 -1494 0 -1493 30 12 c17 7 477 201 1023 431 l992 418 498 -193 c273 -106 686 -266 917 -355 231 -90 466 -181 523 -203 l102 -40 0 330 c0 296 2 330 16 324 12 -4 15 0 12 17 -3 20 -86 52 -808 313 l-805 292 -3 152 c-2 120 0 151 10 148 116 -43 524 -168 547 -168 l31 0 0 945 c0 850 -3 990 -23 933 -3 -12 -126 37 -424 169 l-53 23 0 -795z"/>
            </g>
        </g>
        <g id="l5MwOkS1SBSB7Xa0zzKXm62" fill="rgb(254,255,255)" style="transform: none;">
            <g style="transform: none;">
                <path id="pqfrsnyqs" d="M3296 3408 c-3 -13 -6 -434 -6 -937 0 -804 -2 -912 -15 -907 -8 3 -135 44 -282 92 -148 48 -274 89 -281 91 -10 4 -12 -35 -10 -187 l3 -192 825 -299 c454 -164 826 -299 827 -299 1 0 1 505 0 1122 l-2 1122 -70 29 c-38 16 -79 33 -90 38 -113 47 -850 340 -868 344 -20 5 -25 2 -31 -17z"/>
            </g>
        </g>
        <g id="l51w7ixyLdRsLlRpjHEuR4b" fill="rgb(255,5,5)" style="transform: none;">
            <g style="transform: none;">
                <path id="pCYjEwbED" d="M3300 3748 l1 -353 427 -170 c235 -93 434 -173 442 -176 8 -4 47 -20 85 -36 l70 -29 2 -1090 c1 -599 2 -1095 2 -1102 1 -7 9 -15 19 -18 40 -14 359 -137 374 -145 17 -9 18 66 20 1460 l3 1470 -80 30 c-124 47 -812 302 -1094 407 -140 52 -258 97 -263 100 -4 3 -8 -154 -8 -348z"/>
            </g>
        </g>
    </svg>
</template>

<style scoped lang="scss">

</style>
